import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()({
  dialogContentWithNewLines: {
    whiteSpace: 'pre-wrap',
  },
});

export default useStyles;
